import React, { FC, MouseEventHandler } from "react";
import Tooltip from "../Tooltip";

// import Tooltip from '@base-components/Tooltip';

import { StyledImage, StyledToolTipContainer } from "./Image.styles";

interface ImageProps {
  alt: string;
  srcSet?: string;
  className?: string;
  width?: string;
  height?: string;
  margin?: string;
  padding?: string;
  pointerIsOpen?: boolean;
  onClick?: MouseEventHandler<HTMLImageElement>;
  onMouseDown?: MouseEventHandler<HTMLImageElement>;
  tooltipInfo?: string;
  rotate?: number;
  tabIndex?: number;
  opacity?: number;
  border?: string;
  borderRadius?: string;
  backgroundColor?: string;
}

const Image: FC<ImageProps> = ({
  pointerIsOpen,
  alt,
  srcSet,
  className,
  width,
  height,
  margin,
  padding,
  onClick,
  onMouseDown,
  rotate,
  tabIndex = -1,
  tooltipInfo,
  opacity = 1,
  border,
  borderRadius,
  backgroundColor,
}) => {
  return (
    <StyledToolTipContainer tabIndex={tabIndex}>
      <StyledImage
        alt={alt}
        backgroundColor={backgroundColor}
        border={border}
        borderRadius={borderRadius}
        className={className}
        draggable={false}
        height={height}
        margin={margin}
        padding={padding}
        onClick={onClick}
        onMouseDown={onMouseDown}
        opacity={opacity}
        pointerIsOpen={pointerIsOpen}
        rotate={rotate}
        src={srcSet}
        width={width}
      />

      {tooltipInfo && <Tooltip toolTipInfo={tooltipInfo} />}
    </StyledToolTipContainer>
  );
};

export default Image;
